<div
  clientSideOnly
  *ngIf="isEnabled"
  class="full-loader fixed inset-0 h-screen w-screen bg-[#fcfcfd] z-[999999999999999999] flex flex-col justify-center items-center"
  [class.animate-close]="fireCloseAnimation"
  [class.startImediate]="startImediate"
>
  
  <app-lottie-loader [size]="256"></app-lottie-loader>
  <p *ngIf="msg">{{ msg }}</p>
</div>
